/**
 * Cookie access with the same attributes the pixel SDK uses (path=/, SameSite=Lax),
 * so a cookie we write is indistinguishable from one it wrote.
 */

export function readCookie(name, doc = document) {
  const escaped = String(name).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const match = doc.cookie.match('(^|;)\\s*' + escaped + '\\s*=\\s*([^;]+)');

  if (!match) {
    return null;
  }

  try {
    return decodeURIComponent(match.pop());
  } catch (e) {
    // A half-written percent escape from another script must not throw here.
    return null;
  }
}

export function writeCookie(name, value, maxAgeSeconds, doc = document) {
  const expires = new Date(Date.now() + maxAgeSeconds * 1000).toUTCString();
  const secure = doc.location && doc.location.protocol === 'https:' ? '; Secure' : '';

  doc.cookie =
    name +
    '=' +
    encodeURIComponent(value) +
    '; expires=' +
    expires +
    '; path=/; SameSite=Lax' +
    secure;
}

/**
 * Writes a cookie and reads it straight back — the only reliable way to tell a
 * cookie-blocking browser from a visitor who simply has no cookie yet (spec §3
 * cookie_blocked).
 */
export function cookiesEnabled(doc = document) {
  const probe = '_td_probe';

  try {
    writeCookie(probe, '1', 60, doc);
    const ok = readCookie(probe, doc) === '1';
    writeCookie(probe, '', -1, doc);

    return ok;
  } catch (e) {
    return false;
  }
}
